import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Menu } from "antd";
import CustomAntdIcon from "components/AntdIcon";
import { auth } from "api/endpoints";
import { App } from "context/AppContext";
// import menus from "config/menuList.json";

function SiderMenu() {
  const [selectedKeys, setSelectedKey] = useState(null);
  const [openKeys, setOpenKeys] = useState(null);
  const [items, setItems] = useState([]);
  const location = useLocation();
  const { menus } = App();

  const navigate = useNavigate();

  useEffect(() => {
    var tmp = "";
    var total = 0;
    if (location.pathname !== "/") {
      setSelectedKey([location.pathname]);
      [...location.pathname].forEach((e) => {
        if (total < 3) {
          tmp = tmp + e;
          if (e === "/") {
            ++total;
          }
        }
      });
      setOpenKeys([tmp]);
    }

    const user = localStorage.getItem("data");
    if (!user) {
      navigate(auth.login);
    }
  }, [location, navigate]);

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  useEffect(() => {
    const tmp = [];
    if (menus?.length > 0) {
      menus?.forEach((menu) => {
        var subMenus = menu.Items?.map((subMenu) =>
          getItem(<Link to={subMenu.Route}>{subMenu.Name}</Link>, subMenu.Route, CustomAntdIcon(subMenu.Icon))
        );
        if (menu.Items.length > 0) {
          tmp.push(getItem(menu.Name, menu.Route, CustomAntdIcon(menu.Icon), subMenus));
        }
      });
    }
    setItems(tmp);
  }, [menus]);

  return (
    <Menu
      className={["no-scrollbar", "scrollable-y"]}
      mode="inline"
      theme="dark"
      onSelect={({ key }) => navigate(key)}
      onOpenChange={setOpenKeys}
      openKeys={openKeys}
      selectedKeys={selectedKeys}
      items={items}
    />
  );
}

export default SiderMenu;
